import { DASHBOARD_ROUTES } from './routesLinks'
import atAGlance from 'assets/imgs/navbar/sub-header/at-a-glance.svg'
import atAGlanceSelected from 'assets/imgs/navbar/sub-header/at-a-glance-selected.svg'

import marketModeling from 'assets/imgs/navbar/sub-header/market-modeling.svg'
import marketModelingSelected from 'assets/imgs/navbar/sub-header/market-modeling-selected.svg'

import marketPositioning from 'assets/imgs/navbar/sub-header/market-positioning.svg'
import marketPositioningSelected from 'assets/imgs/navbar/sub-header/market-positioning-selected.svg'

import marketTrends from 'assets/imgs/navbar/sub-header/market-trends.svg'
import marketTrendsSelected from 'assets/imgs/navbar/sub-header/market-trends-selected.svg'

import surveyReport from 'assets/imgs/navbar/sub-header/survey-report.svg'
import surveyReportSelected from 'assets/imgs/navbar/sub-header/survey-report-selected.svg'

import manageData from 'assets/imgs/navbar/sub-header/manage-data.svg'
import manageDataSelected from 'assets/imgs/navbar/sub-header/manage-data-selected.svg'
import { ADMIN as ADMIN_LABELS } from 'constants/textConstants'

export let tabsElements = [
  {
    name: 'Manage Data',
    icon: manageData,
    iconSelected: manageDataSelected,
    phyCode: 'phymanagedata',
    appCode: 'appmanagedata',
  },
  {
    name: 'Survey Report',
    icon: surveyReport,
    iconSelected: surveyReportSelected,
    phyCode: 'physurveyreport',
    appCode: 'appsurveyreport',
  },
  {
    name: 'At-A-Glance',
    icon: atAGlance,
    iconSelected: atAGlanceSelected,
    phyCode: 'phyaag',
    appCode: 'appaag',
  },
  {
    name: 'Market Positioning',
    icon: marketPositioning,
    iconSelected: marketPositioningSelected,
    phyCode: 'phymarketpositioning',
    appCode: 'appmarketpositioning',
  },
  {
    name: 'Market Modeling',
    icon: marketModeling,
    iconSelected: marketModelingSelected,
    phyCode: 'phymarketmodeling',
    appCode: 'appmarketmodeling',
  },
  {
    name: 'Market Trends',
    icon: marketTrends,
    iconSelected: marketTrendsSelected,
    phyCode: 'phymarkettrends',
    appCode: 'appmarkettrends',
  },
  {
    name: 'Opportunity Assessment',
    icon: marketTrends,
    iconSelected: marketTrendsSelected,
    phyCode: 'phyoppassessmt',
  },
]

export let tabElementsAdmin = [
  {
    name: ADMIN_LABELS.NAV.TABS.TEMPLATES,
    icon: manageData,
    iconSelected: manageDataSelected,
    phyCode: 'admintemplate',
    appCode: 'admintemplate',
  },
  {
    name: ADMIN_LABELS.NAV.TABS.MESSAGES_TOOLTIPS,
    icon: surveyReport,
    iconSelected: surveyReportSelected,
    phyCode: 'adminmessages',
    appCode: 'adminmessages',
  },
  {
    name: ADMIN_LABELS.NAV.TABS.MARKET_LIBRARY,
    icon: marketPositioning,
    iconSelected: marketPositioningSelected,
    phyCode: 'adminmarketlibrary',
    appCode: 'adminmarketlibrary',
  },
]

export function isTabElementEnabled(tilesInfo, code) {
  const tileInfo = tilesInfo?.find(c => c.code === code)
  return tileInfo && tileInfo.isEnabled
}

export const findNavbarInfoByUrl = url => {
  const normalizedUrl = (url || '/').replace(/\/+$/, '') || '/'

  if (normalizedUrl === '/admin') {
    return {
      code: 'admintemplate',
      application: 'APP',
      ...DASHBOARD_ROUTES.admin.admintemplate,
    }
  }

  for (const category in DASHBOARD_ROUTES) {
    for (const dashboardCode in DASHBOARD_ROUTES[category]) {
      const baseUrl = (DASHBOARD_ROUTES[category][dashboardCode].url || '').replace(/\/+$/, '')
      if (normalizedUrl === baseUrl || normalizedUrl.startsWith(`${baseUrl}/`)) {
        let application
        if (category === 'physicianDashboards') {
          application = 'Phy'
        } else if (category === 'admin') {
          application = 'Admin'
        } else {
          application = 'APP'
        }
        return {
          code: dashboardCode,
          application,
          ...DASHBOARD_ROUTES[category][dashboardCode],
        }
      }
    }
  }
  return null
}
